import React, { FunctionComponent } from 'react';
import { TableRow } from 'components/UI/V3/Table/Row/TableRow';
import { TableCell } from 'components/UI/V3/Table/Cell/TableCell';
import { Form } from 'model/Forms';
import FormsOptions from '../FormsOptions';
import { formatDate } from '../utils';
import styles from './FormsTableRow.module.scss';

interface FormsTableRowProps {
    form: Form;
    onEdit: () => void;
    onDeleted?: () => void;
    onMenuEdit?: (form: Form) => void;
    onUpdated?: () => void;
    onOpenShareSendClients?: (formId?: number) => void;
    isLast?: boolean;
    isMobile?: boolean;
    timezone: string;
}

const FormsTableRow: FunctionComponent<FormsTableRowProps> = props => {
    return (
        <TableRow
            className={styles.desktopRow}
            onClick={props.onEdit}
            onKeyDown={event => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    props.onEdit();
                }
            }}
            role="button"
            tabIndex={0}
        >
            <TableCell className={styles.nameMainCell}>
                <p className={styles.formName}>{props.form.title}</p>
            </TableCell>
            <TableCell>
                <p>{formatDate(props.form.createdAt, props.timezone)}</p>
            </TableCell>

            <TableCell>
                <p>{formatDate(props.form.updatedAt, props.timezone)}</p>
            </TableCell>

            <TableCell align="right">
                <p>{props.form.sentOnlyCount}</p>
            </TableCell>

            <TableCell align="right">
                <p>{props.form.notCompletedCount}</p>
            </TableCell>

            <TableCell
                isActions
                onClick={event => event.stopPropagation()}
                onKeyDown={event => event.stopPropagation()}
            >
                <FormsOptions
                    form={props.form}
                    onDeleted={props.onDeleted}
                    onEdit={props.onMenuEdit}
                    onUpdated={props.onUpdated}
                    onOpenShareSendClients={props.onOpenShareSendClients}
                />
            </TableCell>
        </TableRow>
    );
};

export default FormsTableRow;
